interface TopicItem {
  name: string;
  heat: string;
  trending: boolean;
}

const topics: TopicItem[] = [
  { name: '恋爱漫画', heat: '8.9w', trending: true },
  { name: '奇幻冒险', heat: '7.2w', trending: true },
  { name: '悬疑推理', heat: '6.5w', trending: false },
  { name: '都市生活', heat: '5.8w', trending: true },
  { name: '古风仙侠', heat: '5.1w', trending: false },
  { name: '热血格斗', heat: '4.7w', trending: false },
  { name: '搞笑日常', heat: '4.3w', trending: true },
  { name: '校园青春', heat: '3.9w', trending: false },
  { name: '科幻未来', heat: '3.4w', trending: false },
  { name: '恐怖惊悚', heat: '2.8w', trending: false },
  { name: '治愈温馨', heat: '2.5w', trending: false },
];

export default function Topics() {
  return (
    <section id="topics" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">
          热门话题
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-8 md:mb-10">
          当下最受关注的漫画类型与热度趋势
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#index"
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-background-200 bg-background-50 hover:bg-primary-50 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                {topic.name}
              </span>
              {topic.trending && (
                <span className="w-5 h-5 flex items-center justify-center text-accent-500">
                  <i className="ri-fire-line text-xs"></i>
                </span>
              )}
              <span className="text-xs text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded">
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}